import React, { useEffect } from "react";

import Aos from "aos";
import "aos/dist/aos.css";

import Menu from "../../Components/Menu";

import Section1_Header from "../S1_Header";
import Section2_About from "../S2_About";
import S6_Tokenomics from "../S4_How To Buy";
import S7_Contract from "../S3_Tokenomics";
import Section8_Leg from "../S5_Footer";

import { PageWrapper } from "../../Styles/style";


const MainPage = (props) => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
    window.addEventListener("load", function () {
      Aos.init();
    });
  }, []);
  return (
    <>

      <PageWrapper style={{overflow:"hidden"}}>
        
          <Menu/>
          <Section1_Header />
          <Section2_About />
          <S7_Contract/>
          <S6_Tokenomics />
            <Section8_Leg />
      </PageWrapper>
    </>
  );
};

export default MainPage;
